import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth, arrowWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_RED } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const a = (state, workState) => (
	<g id="Track-8A-red" transform="translate(1918.000000, 662.000000)">
		<g id="line" stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
			 strokeLinecap="round" strokeWidth={tracksWidth}>
			<path
				d="M21,47.5 L64.5,100.5 L116.035017,137.998663 C126.027966,145.269879 137.282155,150.625789 149.227273,153.794979 L228,174.694374 L228,174.694374"/>
			<polyline id="arrow" strokeWidth={arrowWidth} strokeLinejoin="round"
								transform="translate(14.744758, 31.190196) rotate(-113.000000) translate(-14.744758, -31.190196) "
								points="18.7447582 39.1901957 10.7447582 31.1901957 18.7447582 23.1901957"/>
			<line x1="3.80334163e-13" y1="-1.84227521e-13" x2="15.5" y2="33"/>
		</g>
		<g id="Labe" transform="translate(47.000000, 87.000000)">
			<circle id="Oval-Copy" fill="#FBBAB7" fillRule="evenodd" cx="18" cy="18" r="18"/>
			<circle id="Oval-Copy-4" fill="#FF3B30" fillRule="evenodd" cx="18" cy="18" r="14"/>
			<text id="1C" fontFamily="ALSSectorBold-Bold, ALS Sector" fontSize="14" fontWeight="normal" fill="#FFFFFF">
				<tspan x="9.81494141" y="22">8A</tspan>
			</text>
		</g>
	</g>
);

const Track8ARed = ({ state, workState, onLabelClick }) => (
	<g id="Track8ARed"
		 className="track"
		 transform="translate(1918.000000, 662.000000)"
	>
		<g id="line" stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
			 strokeLinecap="round" strokeWidth={tracksWidth}>
			<path
				d="M21,47.5 L64.5,100.5 L116.035017,137.998663 C126.027966,145.269879 137.282155,150.625789 149.227273,153.794979 L228,174.694374 L228,174.694374"/>
			<TrackArrow transform="translate(14.744758, 31.190196) rotate(-113.000000) translate(-14.744758, -31.190196) "
									points="18.7447582 39.1901957 10.7447582 31.1901957 18.7447582 23.1901957"/>
			<line x1="3.80334163e-13" y1="-1.84227521e-13" x2="15.5" y2="33"/>
		</g>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track8ARed')}
			coords="47.000000, 87.000000"
			text="8A"
			textCoordsX="9.81494141"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
		/>
	</g>
);

Track8ARed.propTypes = trackPropTypes;

export default Track8ARed;
